/**
 * Screenshot Capture Utility
 * Uses html2canvas to capture screenshots of the game map
 */

import html2canvas from 'html2canvas';

/**
 * Capture screenshot of the full game view (map + panels)
 * @returns {Promise<string|null>} Base64 encoded PNG image or null if failed
 */
export async function captureMapScreenshot() {
    // Capture full game view including side panels
    const gameView = document.querySelector('.game-view');

    if (!gameView) {
        console.warn('[screenshotCapture] Game view not found');
        return null;
    }

    try {
        const canvas = await html2canvas(gameView, {
            useCORS: true,
            allowTaint: true,
            backgroundColor: '#1a1a2e',
            scale: 1, // 1:1 scale to keep file size reasonable
            logging: false,
        });

        return canvas.toDataURL('image/png');
    } catch (error) {
        console.error('[screenshotCapture] Failed to capture screenshot:', error);
        return null;
    }
}

/**
 * Capture screenshot of any element by selector
 * @param {string} selector - CSS selector for the element to capture
 * @returns {Promise<string|null>} Base64 encoded PNG image or null if failed
 */
export async function captureElementScreenshot(selector) {
    const element = document.querySelector(selector);

    if (!element) {
        console.warn(`[screenshotCapture] Element not found: ${selector}`);
        return null;
    }

    try {
        const canvas = await html2canvas(element, {
            useCORS: true,
            allowTaint: true,
            backgroundColor: null,
            scale: 1,
            logging: false,
        });

        return canvas.toDataURL('image/png');
    } catch (error) {
        console.error('[screenshotCapture] Failed to capture element:', error);
        return null;
    }
}
